export function getContactsButtonSelectOptions({ addTypes, existingTypes, t }) {
  return addTypes
    .filter(
      typeConfig =>
        !(typeConfig.isUnique && existingTypes.includes(typeConfig.type))
    )
    .map(typeConfig => ({
      label: t(typeConfig.dropdownLabelKey),
      typeConfig,
      value: typeConfig.type,
    }))
}

export function getTooltip({ isLimitReached, t }) {
  return isLimitReached
    ? t('ProfileContactsWidget.IsLimitTooltipTextKey')
    : t('ProfileContactsWidget.IsValueEmptyTooltipTextKey')
}
